import { gql } from '@apollo/client';

export const FETCH_FEATURES = gql`
  query fetchFeatures($where: FeaturesWhereInput) {
    findFeatures(where: $where, first: 10000) {
      edges {
        node {
          objectId
          name
          label
          products {
            ... on Element {
              value
            }
          }
          plans {
            ... on Element {
              value
            }
          }
          module_pointer {
            objectId
            name
          }
        }
      }
    }
  }
`;

export const FETCH_FEATURE = gql`
  query fetchFeatures($key: String) {
    findFeatures(where: { name: { equalTo: $key } }, first: 10) {
      edges {
        node {
          objectId
          name
          label
          products {
            ... on Element {
              value
            }
          }
          module_pointer {
            objectId
            name
          }
        }
      }
    }
  }
`;

export const FETCH_FEATURES_PREFERENCES = gql`
  query fetchDisabledUserFeatures($where: Features_preferenceWhereInput) {
    features_preferences(where: $where, first: 10000) {
      edges {
        node {
          objectId
          key
          disabled
          user_pointer {
            objectId
            first_name
            last_name
          }
          product
        }
      }
    }
  }
`;

export const FETCH_OVERRIDE_FEATURES = gql`
  query fetchDisabledUserFeatures($orgId: ID!) {
    features_preferences(
      where: {
        AND: [
          { org_pointer: { have: { objectId: { equalTo: $orgId } } } }
          { user_pointer: { exists: false } }
          { product: { equalTo: "giotto" } }
        ]
      }
      first: 10000
    ) {
      edges {
        node {
          objectId
          key
          disabled
        }
      }
    }
  }
`;

export const FETCH_DISABLED_USER_FEATURES = gql`
  query fetchDisabledUserFeatures($userId: ID!) {
    features_preferences(
      where: { user_pointer: { have: { objectId: { equalTo: $userId } } } }
      first: 10000
    ) {
      edges {
        node {
          objectId
          key
          user_pointer {
            objectId
            first_name
            last_name
          }
          product
        }
      }
    }
  }
`;

export const DELETE_DISABLED_USER_FEATURE = gql`
  mutation deleteDisabledUserFeature($id: ID!) {
    deleteFeatures_preference(input: { id: $id }) {
      features_preference {
        id
      }
    }
  }
`;

export const CREATE_DISABLED_USER_FEATURE = gql`
  mutation createDisabledUserFeature(
    $fields: CreateFeatures_preferenceFieldsInput
  ) {
    createFeatures_preference(input: { fields: $fields }) {
      features_preference {
        key
        user_pointer {
          objectId
        }
      }
    }
  }
`;

export const UPDATE_DISABLED_USER_FEATURE = gql`
  mutation updateDisabledUserFeature(
    $id: ID!
    $fields: UpdateFeatures_preferenceFieldsInput
  ) {
    updateFeatures_preference(input: { id: $id, fields: $fields }) {
      features_preference {
        objectId
        key
        disabled
        product
      }
    }
  }
`;
